enum EnumRegistrationUpgradeStatus {
    Created = "Created" ,
    Unpaid = "Unpaid", 
    Paid = "Paid" ,
    Deleted = "Deleted",
    Reserved = "Reserved"
}

export default EnumRegistrationUpgradeStatus;